import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';

export default (function (Id) {
  const { isRequestSuccessed, exec, rst } = useRequest({
    url: '',
    name: 'MOLD_SPOTCHECK_DELETE',
    method: 'DELETE',
  });

  useEffect(() => {
    if (Id) {
      exec(`/api/maintain/moldspotcheck/${Id}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Id]);

  return [isRequestSuccessed, rst];
});
